import { Component } from 'react'
import LoadingSpinner from '../LoadingSpinner'

type IFrameComponentProps = {
  url?: string
  style?: { width: number; height: number }
  // description: string
}

class IFrameComponent extends Component<
  IFrameComponentProps,
  { isLoading: boolean }
> {
  state = {
    isLoading: true
  }

  onIFrameLoad = () => this.setState({ isLoading: false })

  render() {
    const { isLoading } = this.state
    const { url, style } = this.props
    const containerClasses = [
      'media-item',
      'message-text',
      'iframe',
      isLoading ? 'loading' : ''
    ].join(' ')

    return (
      <div className={containerClasses}>
        <iframe
          src={url}
          frameBorder="0"
          allow={`accelerometer; encrypted-media; 
            gyroscope; picture-in-picture`}
          onLoad={this.onIFrameLoad}
          allowFullScreen
          style={style}
        />
        {isLoading && <LoadingSpinner />}
      </div>
    )
  }
}

export default IFrameComponent
